import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types.js';

/** One deterministic document per deployment; reads never seed or change a setting. */
@Entity()
export class CallRoutingConfig extends MongoEntity {
  static override _class = 'CallRoutingConfig';
  static override _collectionName = 'call_routing_config';
  constructor(data: PartialEntityData<CallRoutingConfig>) {
    super(data);
  }
  @Field(() => String) targetNumber: Maybe<string>;
  @Field(() => String) deployment: Maybe<string>;
  @Field(() => Date) updatedAt: Maybe<Date>;
  @Field(() => String) updatedBy: Maybe<string>;
}
